import React from "react";
import ISOCertificationImg from "../../../Assets/ISO Certification/CertificationImg.png";

const ISOContent22000 = () => {
  return (
    <>
      <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
        {/* left side */}
        <div className="w-full">
          {/* heading */}
          <div className="py-4 lg:py-10">
            <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
              <h1 className="mb-3">
                <span className="border-b-4 border-[#249742]"> ISO 220</span>
                00:2018 CERTIFICATION
              </h1>
            </div>
          </div>

          {/* content */}
          <div>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              ISO 22000:2018 FSMS is a standard dealing with food safety and is
              developed by International Organization for Standardization. It
              specifies the necessity of food safety management system for the
              organizations representing a food chain such that they could
              validate its ability to control food safety hazards in order to
              ensure that food is safe at the time of human consumption.It is
              applicable to all the organization irrespective of their size
              where they want to implement systems that consistently provide
              safe products for human consumption.
            </p>
          </div>
        </div>

        {/* right side */}
        <div className="grid grid-cols-1">
          <div className="py-0 sm:py-8">
            <img
              src={ISOCertificationImg}
              className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
              alt="Compliance certificate"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOContent22000;
